<template>
  <main>
    <div class="container-tv">
      <div v-if="!items.length">Тренировок на сегодня больше нет. Ждем вас завтра!</div>
      <div v-else class="schedule-day">
        <div class="header-day">
          <h1 class="header-day-title">{{ title }}</h1>
          <h1 class="header-day-title">{{ date }}</h1>
          <img class="h-[54px]" src="~/assets/images/encore-logo-tv.png?v=1" />
        </div>
        <div :key="isAdult" class="scedule">
          <div v-for="item in items" :key="item.id" class="scedule-item">
            <p class="scedule-marker">Balance</p>
            <div class="scedule-content">
              <div class="scedule-text">
                <p class="scedule-time">{{ item.time }}</p>
                <h2 ref="line" class="scedule-title">
                  <span class="scedule-inner">
                    <span class="scedule-inner-content">
                      {{ item.name }}
                    </span>
                  </span>
                </h2>
              </div>
              <p class="scedule-note">{{ item.zone }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const TZ_CLUBS = {
  encore_iset: 'Asia/Yekaterinburg',
}
const SECOND = 1000
const MINUTE = 60 * SECOND

const dayNames = {
  0: 'воскресенье',
  1: 'понедельник',
  2: 'вторник',
  3: 'среду',
  4: 'четверг',
  5: 'пятницу',
  6: 'субботу',
}

export default {
  name: 'TvTimetable',
  layout: 'tv',
  async asyncData(ctx) {
    // await ctx.store.dispatch('modules/tvclasses/setDate', new Date())
    // await Promise.all([
    //   ctx.store.dispatch('modules/tvclasses/getTimetable', {
    //     club: ctx.route.params.club,
    //     age: 'adult',
    //     date: new Date(),
    //   }),
    //   ctx.store.dispatch('modules/tvclasses/getTimetable', {
    //     club: ctx.route.params.club,
    //     age: 'kids',
    //     date: new Date(),
    //   }),
    // ])
  },
  data: ctx => {
    return {
      ageItems: [
        { query: 'adult', text: 'Ближайшие тренировки' },
        { query: 'kids', text: 'Ближайшие тренировки для детей' },
      ],
      date: '',
    }
  },
  computed: {
    isAdult() {
      return !this.$route.query.age || this.$route.query.age === 'adult'
    },
    items() {
      return this.isAdult ? this.timetableAdult : this.timetableKids
    },
    timetableAdult() {
      return this.$store.getters['modules/tvclasses/timetableAdult']
    },
    timetableKids() {
      return this.$store.getters['modules/tvclasses/timetableKids']
    },
    title() {
      // const [item] = this.isAdult ? this.timetableAdult : this.timetableKids
      const date = dayjs(this.items[0]?.date)
      const now = this.$store.getters['modules/tvclasses/now']
      const diff = date.startOf('day').diff(now.startOf('day'), 'day')
      const title =
        diff === 0
          ? 'Ближайшие тренировки'
          : diff === 1
          ? 'Тренировки на завтра'
          : `Тренировки на ${dayNames[date.format('d')]}`
      if (this.isAdult) return title
      return title + ' для детей'
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.setMarquee()
      })
    },
  },
  mounted() {
    const timezone = TZ_CLUBS[this.$route.params.club]
    setInterval(this.fetchTimetable, 3 * MINUTE)
    setInterval(() => this.setDate(new Date()), 0.5 * MINUTE)
    setInterval(() => {
      const date = dayjs(new Date())
      const timezone = TZ_CLUBS[this.$route.params.club]
      this.date = (timezone ? date.tz(timezone) : date).format('HH:mm:ss')
    }, 1000)
    this.fetchTimetable()
    this.setDate(new Date())
    this.setDateTimezone(timezone)
    setInterval(() => {
      if (!this.timetableKids.length) return
      const age = this.isAdult ? 'kids' : 'adult'
      this.$router.replace({ query: { age } })
    }, 9 * SECOND)
    this.setMarquee()
  },
  methods: {
    ...mapActions({
      getTimetable: 'modules/tvclasses/getTimetable',
      setDate: 'modules/tvclasses/setDate',
      setDateTimezone: 'modules/tvclasses/setDateTimezone',
    }),
    setMarquee() {
      ;(this.$refs.line || []).forEach(line => {
        const isOverflowed = line.scrollWidth > line.clientWidth
        if (isOverflowed) {
          line.classList.add('marquee')
        }
      })
    },
    async fetchTimetable() {
      await Promise.all([
        this.getTimetable({
          club: this.$route.params.club,
          age: 'adult',
          date: new Date(),
        }),
        this.getTimetable({
          club: this.$route.params.club,
          age: 'kids',
          date: new Date(),
        }),
      ])
    },
  },
}
</script>

<style lang="postcss">
body::-webkit-scrollbar {
  display: none;
}
.container-tv {
  width: 1920px;
  color: #0b0b0b;
  height: 100vh;
}

.header-day {
  display: flex;
  background-color: #0b0b0b;
  color: #fff;
  padding: 14px 24px 12px 128px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  &-title {
    font-size: 48px;
    line-height: 56px;
    font-weight: 400;
    margin: 0;
  }
}
.scedule {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  font-size: 24px;
  .scedule-item {
    display: flex;
    border-bottom: 2px solid #e0e3e3;
    min-height: calc((100vh - 80px) / 8);
    align-items: center;
    height: 100%;
    overflow: hidden;
    &:last-of-type {
      border-bottom: none;
    }
  }
  .scedule-marker,
  .scedule-text {
    align-items: center;
  }
  .scedule-marker {
    height: 100%;
    width: 80px;
    min-width: 80px;
    justify-content: center;
    margin-right: 48px;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 20px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    padding: 8px 0;
    box-sizing: border-box;
  }
  .scedule-content,
  .scedule-marker,
  .scedule-text {
    display: flex;
  }
  h2 {
    letter-spacing: normal;
    line-height: 4em;
  }
  .scedule-content {
    padding: 40px 0;
    line-height: 4em;
  }
  .scedule-text {
    @apply font-sans font-bold;
  }
  .scedule-time,
  .scedule-title {
    font-size: 3.6em;
    margin-right: 48px;
    width: 264px;
    font-weight: 600;
  }
  .scedule-title {
    overflow: hidden;
    width: 860px;
    display: block;
    white-space: nowrap;
    &.marquee {
      .scedule-inner {
        display: inline-block;
        animation: marquee__inner 5s linear infinite alternate;
      }
      .scedule-inner-content {
        animation: marquee__content 5s linear infinite alternate;
        white-space: nowrap;
        margin-left: -100%;
      }
    }
  }
  .scedule-note {
    display: flex;
    align-items: center;
    font-size: 2em;
    line-height: 1.2em;
    margin-right: 48px;
    width: 544px;
  }
}
@keyframes marquee__inner {
  0%,
  50% {
    margin-left: 0;
  }
  to {
    margin-left: 100%;
  }
}
@keyframes marquee__content {
  0%,
  50% {
    margin-left: 0;
  }
  to {
    margin-left: -100%;
  }
}
</style>
